import React, { Component, Fragment } from "react";
import unidadesSTI from "../../../../constants/unidadesSTI";
import NovoForm from "./Form"
import CardForm from "./CardForm"
import Menu from "./Menu";
import NomeUnidade from "../../../UI/NomeUnidade";
import api from "../../../../services/api";
import MenuSTI from "../../Dashboard/Elementos/MenuSTI";
import Select from "../../Dashboard/Elementos/Select";

export default class Index extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Form",
            user: {},
            categoriaSelecionada: 0,
            unidade: "Todas",
            nomeUnidade: "Todas"
        }
    }

    async componentDidMount() {
        await this.consultarMetasMensaisSTI();
    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevState.categoriaSelecionada !== this.state.categoriaSelecionada) {
            await this.consultarMetasMensaisSTI();
        }
    }

    escolheCategoria = (categoria) => {
        this.setState({ categoriaSelecionada: categoria });
    }

    exibeConteudoForm = (selecionado) => {
        let formularios =  [
            {
                categoria: "CONSULTORIA EM TECNOLOGIA",
                nomes: [
                    "CONSULTORIA EM TECNOLOGIA",
                    "CONSULTORIA EM PROCESSOS PRODUTIVOS",
                    "CONSULTORIA PARA ATENDIMENTO DE LEGISLAÇÕES, NORMAS E REGULAMENTOS TÉCNICOS"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
                nomes: [
                    "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
                    "SERVIÇOS OPERACIONAIS"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
                nomes: [
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO DE PRODUTO",
                    "PROJETOS EM PDI DE PRODUTO",
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO DE PROCESSO",
                    "PROJETOS EM PDI DE PROCESSO"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "METROLOGIA",
                nomes: [
                    "METROLOGIA",
                    "ENSAIOS",
                    "CALIBRAÇÃO"
                ],
                indicadoresnome: ["Número de Atendimento", "Calibrações", "Ensaios", "Relatórios/Laudos", "receita", "despesa"],
                indicadoresid: ["numeroAtendimento", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"],
            },
            {
                categoria: "SERVIÇOS COMPLEMENTARES",
                nomes: [
                    "SERVIÇOS COMPLEMENTARES",
                    "CONSULTORIA EM GESTÃO EMPRESARIAL (SERVIÇOS INTERNOS SEM RECEITA)"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "despesa"],
            }
            
        ]
        return formularios[selecionado]
    }
    
    /*
    consultarMetasMensaisSTI = async () => {
        let metas = await api.get("/sti/metasmensais");
        metas = metas.data.metasMensaisSTI;
        this.setState({ metas })
    }
    */

    select = (event) => {
        
        let nome = unidadesSTI.parseNomeCurtoSTI(event.target.value);

        this.setState({ unidade: event.target.value, nomeUnidade: nome });
    }

    somarTodas = (metas) => {
        let categorias = metas.map(({categoria}) => categoria)
        categorias = [...new Set(categorias)]
        let valorTodas = categorias.map(categoria => {

            let filter = metas.filter(prop => prop.categoria === categoria);
            let valores = this.novaSoma(filter);
            return {
                categoria,
                unidade: 'Todas',
                valores
            }

        })
        return [...metas, ...valorTodas]
    }

    filtrar = (metas, unidade) => {
        if(unidade !== "Todas") {
            metas = metas.filter(v => v.unidade === unidade);
        }
        else {
            metas = this.somarTodas(metas);
        }
        return metas;
    }

    agrupar = (metas, propriedade) => {

        metas = metas.reduce((acc, atual) => {
            if(acc.hasOwnProperty(atual[propriedade])) {
                acc[atual[propriedade]].push(atual);
            }
            else {
                acc[atual[propriedade]] = [atual];
            }
            return acc;
        }, {});
        
        return metas;

    }

    consultarMetasMensaisSTI = async () => {

        let metas = await api.get("/sti/metas");
        let metasMensais = await api.get("/sti/metasmensais");
        
        metasMensais = metasMensais.data.metasMensaisSTI
        metas = metas.data.metas;

        let novasmetas = [] 
        let agrupado = this.agrupar(metas, "Sigla");
        Object.keys(agrupado).map((v, i) => {
            let agrupadoPorNome = this.agrupar(agrupado[v], "categoria");
            Object.keys(agrupadoPorNome).map((attr, i) => {
                let soma = this.soma({ metas: agrupadoPorNome[attr] });
                let obj = {
                    categoria: attr,
                    unidade: v,
                    valores: soma
                }
                novasmetas.push(obj)
            });
        });

        this.setState({ metas: novasmetas, metasMensais });

    }

    soma = (argumentos) => {
        let { metas, unidade } =  argumentos;
        
        let linha =  [
            "CONSULTORIA EM TECNOLOGIA",
            "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
            "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
            "METROLOGIA",
            "SERVIÇOS COMPLEMENTARES"
        ]

        //let indicadoresnome = ["Número de Atendimento", "Horas Técnicas", "Calibrações", "Ensaios", "Relatórios/Laudos", "Receita", "Despesa"]
        let indicadoresnome = ["numeroAtendimento", "horasTecnicas", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"];

        if(["ISTAI", "ISTTC", "ISTEO"].includes(unidade)) {
            //metas = metas.filter(meta => linha.includes(meta.categoria) && meta.unidade === unidade);
            metas = metas.filter(meta => meta.Sigla === unidade);
        }
        else {
            //metas = metas.filter(meta => linha.includes(meta.categoria));
        }

        let soma = {}
        indicadoresnome.forEach(ind => {
            let vetor = Array(12).fill(0);
            soma[ind] = vetor
        });

        metas.map(val => {
            indicadoresnome.map((indicador) => {
                if(val[indicador]) {
                    val[indicador].map((valorMensal, i) => {
                        soma[indicador][i] += valorMensal;
                    });
                }
            });
        });
        return soma;

    }

    somaTotalLinhaAtuacao = (metas, formularioSelecionado) => {
        try {
            metas = metas && metas.filter(categoria => formularioSelecionado.includes(categoria.categoria.toUpperCase()) && categoria.unidade !== 'Todas')
            let soma = this.novaSoma(metas)
            return soma;
        } catch(erro) {
        }

    }

    novaSoma = (metas) => {
        let indicadoresnome = ["numeroAtendimento", "horasTecnicas", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"];
        metas = metas.map(meta => meta.valores);

        let soma = {}
        indicadoresnome.forEach(ind => {
            let vetor = Array(12).fill(0);
            soma[ind] = vetor
        });
        
        metas.map(val => {
            indicadoresnome.map((indicador) => {
                if(val[indicador]) {
                    val[indicador].map((valorMensal, i) => {
                        soma[indicador][i] += valorMensal;
                    });
                }
            });
        });
        
        return soma;
    }

    render() {

        let { categoriaSelecionada, metas, unidade, nomeUnidade, metasMensais } = this.state;
        let formularioSelecionado = this.exibeConteudoForm(categoriaSelecionada);
        let { indicadoresnome, indicadoresid, categoria } = formularioSelecionado;
        //let metasDaUnidade = this.state.metas && this.state.metas.filter(v => v.unidade === /*this.props.match.params.unidade.toUpperCase() ||*/ "ISTEO");
        let metasDaUnidade = metas && this.filtrar(metas, unidade);

        let teste = this.somaTotalLinhaAtuacao(metasDaUnidade, formularioSelecionado.nomes)
        
        metasDaUnidade && metasDaUnidade.push({
            categoria,
            unidade,
            valores: teste
        });

        return (
            <Fragment>

                <div className="content">

                    <NomeUnidade unidade={"Relatórios STI"} />
                    <div className="row">
                        <div className="col-md-12 ml-auto mr-auto">
                            <MenuSTI />
                            <Select option={"unidades"} select={this.select} exibeTodas={true} />
                        </div>
                    </div>

                    <CardForm produto={formularioSelecionado.categoria} onSubmit={this.onSubmit} titulo={"Linha de Atuação"} subtitulo={nomeUnidade}>
                        <Menu escolheCategoria={this.escolheCategoria} categoriaSelecionada={categoriaSelecionada} />
                        {formularioSelecionado.nomes.map(categoria => {
                            let disabled = categoria === formularioSelecionado.categoria ? true : false;
                            return(
                                <Fragment>
                                    <div className="card card-user p-2">
                                        <div className="card-header">
                                            <div className="table-responsive w-100 d-block">
                                                <NovoForm 
                                                    categoria={categoria}
                                                    id={categoria}
                                                    indicadoresid={indicadoresid}
                                                    indicadoresnome={indicadoresnome}
                                                    metasDaUnidade={metasDaUnidade}
                                                    formDisabled={disabled}
                                                    unidade={unidade}
                                                    metasMensais={metasMensais}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </Fragment>
                            )
                        })}
                    </CardForm>

                </div>

            </Fragment>
        )
    }
}